import { Box, Stack } from '@mantine/core'
import MyRooms from './MyRooms'
import Invitations from './Invitations'
import PublicRooms from './PublicRooms'
import { useModalStack } from '../ui/ModalStack'

export default function Rooms() {
    const { popModal } = useModalStack()

    return (
        <Box p="md">
            <Stack gap="lg" px="xs">
                <Invitations />
                <MyRooms onNavigate={popModal} />
                <PublicRooms onNavigate={popModal} />
            </Stack>
        </Box>
    )
}

